import moment from 'moment'

export default defineNuxtPlugin((nuxtApp) => {
  // Provide as composable injection (useNuxtApp().$moment)
  nuxtApp.provide('moment', moment)

  // Expose as this.$moment for Options API components/mixins
  if (!nuxtApp.vueApp.config.globalProperties.$moment) {
    nuxtApp.vueApp.config.globalProperties.$moment = moment
  }
})
